const getMegaphoneByProductId = (products, productId) => {
  return products.length && (products.find((megaphone) => {
    return megaphone.product_id === parseInt(productId, 10) && megaphone
  }) || {})
}

const convertPositionToPercent = (position) => {
  return position / 3
}

export {
  getMegaphoneByProductId,
  convertPositionToPercent
}
